import React from 'react';
import moment from 'moment';
import { I18n } from '@aws-amplify/core';

import { Header, HeaderDate, HeaderTexts, Subtitle, Title } from './styles';

const SINGLE_FILE_SUBTITLE = 'Select below the video file referring to the tasks that make up the cycle';
const MULTIPLE_FILES_SUBTITLE = 'Select below the video files referring to the tasks that make up the cycle';

interface SubTitleProps {
	isSingleSelection?: boolean;
	subtitle?: string;
}

export function SubTitle({ isSingleSelection = false, subtitle }: Readonly<SubTitleProps>): JSX.Element {
	const today = moment().format('L');
	const defaultSubtitle = isSingleSelection ? SINGLE_FILE_SUBTITLE : MULTIPLE_FILES_SUBTITLE;
	const text = subtitle ?? defaultSubtitle;

	return (
		<Header>
			<HeaderTexts>
				<Title>{I18n.get('Video selection')}</Title>
				<Subtitle>{I18n.get(text)}</Subtitle>
			</HeaderTexts>
			<HeaderDate>{today}</HeaderDate>
		</Header>
	);
}
